import {
  Component,
  Input,
  OnInit,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
} from '@angular/core';
import { TopPurchase } from '@app/customer-reporting/models/top-purchases.model';
import { PlatformService } from '@panamax/app-state';
import { Product } from '@shared/models/product.model';
import { ProductService } from '@shared/services/product/product.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-top-purchases-card',
  templateUrl: './top-purchases-card.component.html',
  styleUrls: ['./top-purchases-card.component.scss'],
})
export class TopPurchasesCardComponent implements OnInit {
  @Input() purchase: TopPurchase;
  @Input() sortBy: 'Dollars' | 'Cases' = 'Dollars';

  private _productNameEl: ElementRef;
  @ViewChild('productName', { static: false }) set productName(
    el: ElementRef | undefined,
  ) {
    if (el) {
      this._productNameEl = el;
      setTimeout(() => this.checkTruncation());
    }
  }
  get productName(): ElementRef | undefined {
    return this._productNameEl;
  }

  product$: Observable<Product>;
  isTruncated = false;

  get isMobile(): boolean {
    return (
      this.platformService.platformType ===
      this.platformService.platformEnum.mobile
    );
  }

  constructor(
    public platformService: PlatformService,
    private productService: ProductService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.productService.loadProduct(Number(this.purchase?.productID));
    this.product$ = this.productService.getProduct(
      Number(this.purchase?.productID),
    );
  }

  checkTruncation(): void {
    if (this.productName) {
      const element = this.productName.nativeElement;
      const isNowTruncated = element.scrollHeight > element.clientHeight;
      if (this.isTruncated !== isNowTruncated) {
        this.isTruncated = isNowTruncated;
        this.cdr.detectChanges();
      }
    }
  }
}
